import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output, SimpleChanges,
    ViewContainerRef,
    inject, SecurityContext
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { BehaviorSubject, of  } from 'rxjs';
import { CmsService, PageNotificationService, LanguageService, EventBusService } from '@signature-it/ngx-generic/services';
import { DynamicGadgetsService } from '@signature-it/ngx-generic/services/gadgets';
import { ILanguage, ICmsParams } from '@signature-it/ngx-generic/interfaces';
import {EventData, EventName} from '@signature-it/ngx-generic/classes';

@Component({
    selector: 'cms',
    templateUrl: './cms.html',
    standalone: false
})
export class CmsComponent implements AfterViewInit, OnInit, OnChanges {
    loading: boolean; // TODO: implement loading
    content: any; // SafeHtml
    lang: ILanguage;
    languageSelected$: BehaviorSubject<ILanguage>;
    contentLoader$ = new BehaviorSubject(null);

    @Input() title: string;
    @Input() cmsPlaceHolders: ICmsParams[];
    @Input() quiet = true;
    @Input() cmsFound = true;
    @Input() cacheable = true;
    @Input() replaceTokenKeys = {};
    @Output() cmsFoundChange = new EventEmitter();

    constructor(private notifySvc: PageNotificationService,
                private langSvc: LanguageService,
                private sanitizer: DomSanitizer,
                private activatedRoute: ActivatedRoute,
                private cmsSvc: CmsService,
                private router: Router,
                private dynamicGadgetsService: DynamicGadgetsService,
                private viewContainerRef: ViewContainerRef,
                protected eventBusService: EventBusService) {
        this.languageSelected$ = this.langSvc.languageSelected$;
        this.dynamicGadgetsService.setRootViewContainerRef(viewContainerRef);
    }

    ngAfterViewInit(): void {
        this.lang = this.langSvc.getCurrentLanguage(); // from session
        if(this.lang.code !== "") {
            this.requestContent();
        } else {
            this.languageSelected$.subscribe((lang: ILanguage) => { // on language was selected
                if(lang) {
                    this.lang = lang;
                    this.requestContent();
                }
            });
        }
    }

    requestContent() {
        const notAvailable= 'Cms not available';
        const notFound= 'Entity was not found.';
        // set cms content by lang code & cms' title
        if (typeof this.title == 'undefined' || this.title === "") {
            console.error('No title was specified for cms.');
            this.cmsFoundChange.emit(false);
            this.eventBusService.emit(new EventData(`${EventName.CMS_LOAD}-${this.title}`, false));
            return false;
        }
        this.cmsSvc
            .getByTitle(this.title, this.lang,this.cmsPlaceHolders, this.cacheable)
            .subscribe(
                (content: string) => {
                    if (content === notAvailable || content === notFound || !Object.keys(content).length){
                        this.errorRequest(content);
                        return;
                    }
                    this.content = content;
                    this.cmsFoundChange.emit(true);
                    this.eventBusService.emit(new EventData(`${EventName.CMS_LOAD}-${this.title}`, true));

                    this.onContentLoaded$({
                        title: this.title,
                        content: this.content
                    });
                    if (this.title === 'ngx-admin-dashboard') {
                        setTimeout(() => {
                            this.dynamicGadgetsService.addDynamicGadgets();
                        }, 0);
                    }

                },
                error => {
                    this.errorRequest(error);
                }
            );
    }

    errorRequest(error) {
        this.cmsFoundChange.emit(false);
        this.eventBusService.emit(new EventData(`${EventName.CMS_LOAD}-${this.title}`, false));
        if (!this.quiet) {
            this.notifySvc.set(error).show();
        }
    }

    private onContentLoaded$(obj: object) {
        return of(obj)
            .subscribe((value: any) => {
                this.contentLoader$.next(obj);
            });
    }
    ngOnInit() {
        window.addEventListener('message', (event) => {
            if (event.data) {
                try {
                    const data = JSON.parse(event.data);
                    if (data.navigateToUrl) {
                        if (data.navigateToUrl.startsWith('http') && data.navigateToUrl.replace(/^https?:\/\//, '').startsWith(location.hostname)) {
                            location.href = this.sanitizer.sanitize(SecurityContext.URL,data.navigateToUrl);
                        } else {
                            this.router.navigate([data.navigateToUrl.split('?')[0]], {queryParams: this.router.parseUrl(data.navigateToUrl).queryParams});
                        }
                    }
                } catch (e) {}
            }
        });

    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['title'] && this.title && this.lang) {
            this.requestContent();
        }
    }

}
